// src/components/AdminRoute.js
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

function AdminRoute({ children }) {
    const { user } = useAuth();

    // Si hay un usuario y su rol es 'admin', permite el acceso.
    // Si no, redirige a la página de inicio.
    if (user && user.role === 'admin') {
        return children;
    }

    return <Navigate to="/" />;
}

export default AdminRoute;
